/* eslint-disable */
import React from 'react';
import {
  HiSearch,
  HiChatAlt2,
  HiArrowCircleUp,
  HiPlus,
  HiX,
  HiGlobeAlt,
  HiLibrary,
  HiPaperAirplane
} from 'react-icons/hi';
import useQAFacade from '../facades/useQAFacade';
import QAPageBanner from '../components/ProductionBanners/QAPageBanner';

const QAPage = () => {
  const {
    isModalOpen,
    setIsModalOpen,
    selectedQuestion,
    setSelectedQuestion,
    scopeFilter,
    setScopeFilter,
    newQuestion,
    setNewQuestion,
    replyText,
    setReplyText,
    searchTerm,
    setSearchTerm,
    filteredQuestions,
    loadingPosts,
    handlePostQuestion,
    handlePostReply,
    handleUpvote,
    handleSearch,
  } = useQAFacade();

  const isDevelopment = process.env.NODE_ENV === 'development';

  if(!isDevelopment) {
    return <QAPageBanner/>
  }

  return (
    <div className="min-h-screen bg-slate-50 pb-20 font-sans">

      {/* HEADER & TABS */}
      <div className="bg-white border-b border-slate-200 pt-12 pb-8 px-6 sticky top-0 z-40 shadow-sm">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-6">
          <div className="text-center">
            <h1 className="text-3xl font-black text-slate-900 uppercase">
              {scopeFilter === 'public' ? 'Public' : 'Campus'} <span className="text-blue-600">Discussions</span>
            </h1>
            <p className="text-slate-400 text-sm font-bold mt-1">
              {scopeFilter === 'public' ? 'Global knowledge sharing across all colleges' : 'Private discussions for your college campus'}
            </p>
          </div>

          <div className="flex bg-slate-100 p-1.5 rounded-2xl w-full max-w-sm">
            <button
              onClick={() => setScopeFilter('public')}
              className={`flex-1 py-3 rounded-xl text-xs font-black uppercase transition-all flex items-center justify-center gap-2 ${scopeFilter === 'public' ? 'bg-white shadow-sm text-blue-600' : 'text-slate-500 hover:text-slate-800'}`}
            >
              <HiGlobeAlt size={18} /> Public
            </button>
            <button
              onClick={() => setScopeFilter('campus')}
              className={`flex-1 py-3 rounded-xl text-xs font-black uppercase transition-all flex items-center justify-center gap-2 ${scopeFilter === 'campus' ? 'bg-white shadow-sm text-blue-600' : 'text-slate-500 hover:text-slate-800'}`}
            >
              <HiLibrary size={18} /> My Campus
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 mt-8 grid grid-cols-1 md:grid-cols-4 gap-8">

        {/* MAIN FEED */}
        <div className="md:col-span-3 space-y-4">
          <div className="flex flex-col sm:flex-row gap-4 justify-between items-center mb-6">
            <div className="relative w-full sm:max-w-xs">
              <HiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                type="text"
                placeholder={`Search ${scopeFilter} posts...`}
                className="w-full bg-white border border-slate-200 rounded-xl pl-12 pr-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 font-medium transition-all"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="w-full sm:w-auto bg-blue-600 text-white px-6 py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2 hover:bg-blue-700 active:scale-95 transition-all shadow-lg shadow-blue-200"
            >
              <HiPlus /> New Post
            </button>
          </div>

          {/* FEED ITEMS */}
          {loadingPosts ? (
            // Loading skeleton
            Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="bg-white border border-slate-200 p-5 rounded-2xl animate-pulse">
                <div className="flex gap-4">
                  <div className="flex flex-col items-center justify-start py-1 px-2 rounded-xl">
                    <div className="w-7 h-7 bg-slate-200 rounded-full"></div>
                    <div className="w-4 h-3 bg-slate-200 rounded mt-1"></div>
                  </div>
                  <div className="flex-1">
                    <div className="h-4 bg-slate-200 rounded mb-2"></div>
                    <div className="h-3 bg-slate-200 rounded w-3/4"></div>
                    <div className="flex items-center justify-between mt-4">
                      <div className="h-3 bg-slate-200 rounded w-20"></div>
                      <div className="h-5 bg-slate-200 rounded w-16"></div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            filteredQuestions.map((q) => (
            <div
              key={q._id}
              onClick={() => q._id && typeof q._id === 'string' && q._id.length > 10 && q._id !== 'undefined' && setSelectedQuestion(q)}
              className="bg-white border border-slate-200 p-5 rounded-2xl hover:border-blue-400 hover:shadow-md transition-all cursor-pointer group"
            >
              <div className="flex gap-4">

                {/* Upvote Column */}
                <div
                  className="flex flex-col items-center justify-start py-1 px-2 rounded-xl hover:bg-slate-50 transition-colors"
                  onClick={(e) => q._id && typeof q._id === 'string' && q._id.length > 10 && q._id !== 'undefined' && handleUpvote(e, q._id)}
                >
                  <HiArrowCircleUp
                    size={28}
                    className={`transition-all ${q.isupvoted ? 'text-blue-600 scale-110' : 'text-slate-200 hover:text-blue-400'}`}
                  />
                  <span className={`text-xs font-black mt-1 ${q.isupvoted ? 'text-blue-600' : 'text-slate-500'}`}>
                    {q.upvotes}
                  </span>
                </div>

                {/* Content Column */}
                <div className="flex-1">
                  <div className="flex gap-2 mb-2">
                    {q.tags.map(tag => (
                      <span key={tag} className="text-[10px] font-black text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md uppercase tracking-wider">#{tag}</span>
                    ))}
                  </div>
                  <h3 className="text-lg font-bold text-slate-800 group-hover:text-blue-700 transition-colors leading-snug">
                    {q.question}
                  </h3>
                  <div className="flex items-center justify-between mt-4">
                    <span className="text-[11px] text-slate-400 font-medium">
                      <span className="text-slate-700 font-bold">{q.author}</span> • {q.time}
                    </span>
                    <div className={`flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-lg transition-colors ${q.commentCount > 0 ? 'bg-blue-50 text-blue-600' : 'bg-slate-50 text-slate-500'}`}>
                      <HiChatAlt2 size={16} />
                      {q.commentCount} {q.commentCount === 1 ? 'Reply' : 'Replies'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
          )}

          {/* Empty State */}
          {!loadingPosts && filteredQuestions.length === 0 && (
            <div className="text-center py-20 bg-white rounded-3xl border-2 border-dashed border-slate-200 flex flex-col items-center justify-center">
              <HiChatAlt2 size={48} className="text-slate-200 mb-4" />
              <p className="text-slate-500 font-bold text-lg">It's quiet in here...</p>
              <p className="text-slate-400 text-sm mt-1 mb-6">Be the first to start a discussion in {scopeFilter}!</p>
              <button onClick={() => setIsModalOpen(true)} className="text-blue-600 font-bold text-sm bg-blue-50 px-6 py-2 rounded-xl hover:bg-blue-100 transition-colors">
                Start a Discussion
              </button>
            </div>
          )}
        </div>

        {/* SIDEBAR */}
        <div className="md:col-span-1 space-y-4 hidden md:block">
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 p-6 rounded-3xl shadow-lg text-white">
            <h4 className="font-black text-[10px] uppercase tracking-widest text-blue-400 mb-2">Community Rules</h4>
            <ul className="text-xs space-y-3 font-medium text-slate-300">
              <li className="flex gap-2 items-start"><span>👋</span> Be respectful to juniors and seniors alike.</li>
              <li className="flex gap-2 items-start"><span>🎯</span> Keep titles clear and specific.</li>
              <li className="flex gap-2 items-start"><span>🏢</span> Use tags to help others find your post.</li>
            </ul>
          </div>
        </div>
      </div>

      {/* --- MODAL: POST NEW QUESTION --- */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 animate-in fade-in duration-200">
          <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={() => setIsModalOpen(false)}></div>
          <form onSubmit={handlePostQuestion} className="bg-white w-full max-w-lg rounded-[2rem] p-6 sm:p-8 relative z-10 shadow-2xl">
            <div className="flex justify-between items-center mb-8">
              <h3 className="text-xl font-black text-slate-900 uppercase tracking-tight">Create <span className="text-blue-600">Post</span></h3>
              <button type="button" onClick={() => setIsModalOpen(false)} className="p-2 bg-slate-50 rounded-full text-slate-400 hover:text-red-500 hover:bg-red-50 transition-all">
                <HiX size={20} />
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="text-[10px] font-black uppercase text-slate-400 tracking-widest">Where should this post go?</label>
                <div className="flex gap-3 mt-2">
                  {['public', 'campus'].map(s => (
                    <button
                      key={s} type="button"
                      onClick={() => setNewQuestion({ ...newQuestion, scope: s })}
                      className={`flex-1 py-3 rounded-xl text-xs font-black uppercase border-2 transition-all flex items-center justify-center gap-2
                      ${newQuestion.scope === s ? 'border-blue-600 bg-blue-50 text-blue-600 shadow-sm' : 'border-slate-100 text-slate-400 hover:bg-slate-50'}`}
                    >
                      {s === 'public' ? <HiGlobeAlt size={16} /> : <HiLibrary size={16} />}
                      {s === 'public' ? 'Global Forum' : 'My Campus'}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label className="text-[10px] font-black uppercase text-slate-400 tracking-widest">Your Question / Topic</label>
                <textarea
                  required
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 mt-2 focus:bg-white focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 focus:outline-none font-medium text-slate-700 transition-all resize-none"
                  rows="3"
                  placeholder="e.g. What to expect in the upcoming TCS NQT?"
                  value={newQuestion.title}
                  onChange={(e) => setNewQuestion({ ...newQuestion, title: e.target.value })}
                ></textarea>
              </div>

              <div>
                <label className="text-[10px] font-black uppercase text-slate-400 tracking-widest">Description (Optional)</label>
                <textarea
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl p-4 mt-2 focus:bg-white focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 focus:outline-none font-medium text-slate-700 transition-all resize-none"
                  rows="3"
                  placeholder="Provide more details about your question..."
                  value={newQuestion.content}
                  onChange={(e) => setNewQuestion({ ...newQuestion, content: e.target.value })}
                ></textarea>
              </div>

              <div className="pt-2">
                <button
                  type="submit"
                  disabled={!newQuestion.title.trim()}
                  className="w-full bg-blue-600 disabled:bg-slate-300 disabled:cursor-not-allowed text-white py-4 rounded-xl font-black uppercase tracking-widest hover:bg-blue-700 active:scale-[0.98] transition-all shadow-lg shadow-blue-200"
                >
                  Publish Post
                </button>
              </div>
            </div>
          </form>
        </div>
      )}

      {/* --- SLIDE-IN: DISCUSSION VIEW --- */}
      {selectedQuestion && (
        <div className="fixed inset-0 z-[100] flex items-center justify-end animate-in fade-in duration-200">
          <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={() => setSelectedQuestion(null)}></div>

          <div className="bg-white w-full max-w-2xl h-full relative z-10 shadow-2xl flex flex-col animate-in slide-in-from-right duration-300 sm:rounded-l-[2rem]">

            {/* Thread Header */}
            <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-white sm:rounded-tl-[2rem]">
              <div className="flex items-center gap-2">
                <span className={`text-[9px] font-black px-2 py-1 rounded-md uppercase tracking-widest flex items-center gap-1 ${selectedQuestion.scope === 'public' ? 'bg-blue-50 text-blue-600' : 'bg-purple-50 text-purple-600'}`}>
                  {selectedQuestion.scope === 'public' ? <HiGlobeAlt /> : <HiLibrary />}
                  {selectedQuestion.scope}
                </span>
                <h3 className="font-black text-slate-900 uppercase text-xs tracking-widest">Thread</h3>
              </div>
              <button onClick={() => setSelectedQuestion(null)} className="p-2 bg-slate-50 rounded-full text-slate-400 hover:text-red-500 hover:bg-red-50 transition-all">
                <HiX size={20} />
              </button>
            </div>

            {/* Thread Content */}
            <div className="flex-1 overflow-y-auto p-6 sm:p-8 bg-slate-50/50">
              <div className="mb-8 bg-white p-6 rounded-3xl border border-slate-100 shadow-sm">
                <h2 className="text-xl sm:text-2xl font-black text-slate-900 mb-4 leading-tight">
                  {selectedQuestion.question}
                </h2>
                <div className="flex items-center justify-between border-t border-slate-50 pt-4 mt-2">
                  <p className="text-[11px] text-slate-500 font-bold">
                    <span className="text-slate-800">{selectedQuestion.author}</span> • {selectedQuestion.time}
                  </p>
                  <div className="flex gap-2">
                    {selectedQuestion.tags.map(tag => (
                      <span key={tag} className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">#{tag}</span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Replies Section */}
              <div className="space-y-4">
                <h4 className="text-xs font-black text-slate-400 uppercase tracking-widest pl-2 mb-4">
                  {selectedQuestion.replies.length} {selectedQuestion.replies.length === 1 ? 'Reply' : 'Replies'}
                </h4>

                {selectedQuestion.replies.length > 0 ? (
                  selectedQuestion.replies.map(reply => (
                    <div key={reply.id} className="bg-white p-5 rounded-3xl rounded-tl-sm border border-slate-100 shadow-sm ml-4">
                      <p className="text-sm text-slate-700 font-medium mb-3 leading-relaxed whitespace-pre-wrap">{reply.text}</p>
                      <p className="text-[10px] font-black text-blue-600 uppercase tracking-widest flex items-center gap-2">
                        <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center text-blue-700">{reply.user.charAt(0)}</div>
                        {reply.user} <span className="text-slate-300 ml-auto lowercase font-medium">{reply.time || 'Just now'}</span>
                      </p>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-10">
                    <div className="w-16 h-16 bg-blue-50 text-blue-200 rounded-full flex items-center justify-center mx-auto mb-3">
                      <HiChatAlt2 size={32} />
                    </div>
                    <p className="text-slate-500 font-bold text-sm">No replies yet.</p>
                    <p className="text-slate-400 text-xs mt-1">Be the first to share your thoughts!</p>
                  </div>
                )}
              </div>
            </div>

            {/* Reply Input Area */}
            <div className="p-4 sm:p-6 border-t border-slate-100 bg-white">
              <form onSubmit={handlePostReply} className="flex gap-3">
                <input
                  type="text"
                  value={replyText}
                  onChange={(e) => setReplyText(e.target.value)}
                  placeholder="Write a helpful reply..."
                  className="flex-1 bg-slate-50 border border-slate-200 rounded-2xl px-5 py-3.5 text-sm focus:outline-none focus:bg-white focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 font-medium transition-all"
                />
                <button
                  type="submit"
                  disabled={!replyText.trim()}
                  className="bg-blue-600 disabled:bg-slate-300 disabled:text-slate-100 text-white px-6 rounded-2xl font-black text-sm hover:bg-blue-700 active:scale-95 transition-all shadow-md flex items-center gap-2"
                >
                  <span className="hidden sm:inline uppercase tracking-widest">Send</span>
                  <HiPaperAirplane size={18} className="rotate-90" />
                </button>
              </form>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default QAPage;